import PropTypes from 'prop-types';
import React from 'react';

// components
import Icon from '../../atoms/Icon';
import H2 from '../../atoms/H1';
import P from '../../atoms/P';

// styles
import styles from './style.scss';

function FailureMessage({ title, message }) {
  return (
    <div className={styles['failure-message']}>
      <Icon iconName="icon-circle-error" size={40} className={styles['failure-message__icon']} />
      <H2 className={styles['failure-message__title']}>{title}</H2>
      <P className={styles['failure-message__content']}>{message}</P>
    </div>
  );
}

FailureMessage.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default FailureMessage;
